import React, { useMemo } from "react"
import { Col, Row, Card, CardBody } from "reactstrap"

// Custom Components
import TableContainer from "../../../components/Common/TableContainer"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useContactFormMessages } from "hooks/useContactForm"
import { useListParams } from "hooks/useListParams"
import { formatReadableDate } from "utils/formatDate"
import { Link } from "react-router-dom"
import TruncateText from "components/Common/TruncateText"
import GlobalInputSearch from "components/Common/GlobalInputSearch"

const MessageList = () => {
  document.title = "Message List"

  // Custom hook for managing URL search parameters
  const {
    params,
    setPage,
    setSearch,
    resetParams,
    hasActiveFilters,
    updateParams,
  } = useListParams({
    page: 1,
    search: "",
  })

  // Memoized query parameters for the API call
  const queryParams = useMemo(
    () => ({
      page: params.page,
      per_page: 10,
      ...(params.search && { search: params.search }),
    }),
    [params.page, params.search]
  )

  const { data: messageResponse, isLoading } =
    useContactFormMessages(queryParams)

  const messageData = messageResponse?.data?.data || []
  const paginationInfo = messageResponse?.data

  // Table column definition
  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "id",
        cell: ({ row }) => (
          <Link to="#" className="text-body fw-bold">
            {row.original.id}
          </Link>
        ),
      },
      {
        header: "Name",
        accessorKey: "name",
      },
      {
        header: "Email",
        accessorKey: "email",
      },
      {
        header: "Mobile",
        accessorKey: "mobile",
      },
      {
        header: "Message",
        accessorKey: "message",
        cell: ({ row }) => (
          <TruncateText text={row.original.message} limit={30} />
        ),
      },
      {
        header: "Date",
        accessorKey: "created_at",
        cell: ({ row }) =>
          row.original.created_at
            ? formatReadableDate(row.original.created_at)
            : "-",
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Message" breadcrumbItem="Message Lists" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom ">
                  <Row className="justify-content-between align-items-center">
                    <Col xs={12} sm={6}>
                      <h5 className="mb-0">
                        Message List{" "}
                        <span className="badge badge-soft-info">
                          {paginationInfo?.total ?? 0}
                        </span>
                      </h5>
                    </Col>
                  </Row>
                </CardBody>
                <CardBody>
                  <Row className="mb-3">
                    <Col sm={4}>
                      <GlobalInputSearch
                        value={params.search}
                        onChange={setSearch}
                      />
                    </Col>
                  </Row>
                  <TableContainer
                    columns={columns}
                    data={messageData}
                    isPagination={true}
                    paginationInfo={paginationInfo}
                    onPageChange={setPage}
                    loading={isLoading}
                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default MessageList
